import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ICommentModel } from '@fi-app/shared/models';
import { FiCommentsListHelperService } from '../../services/fi-comments-list-helper.service';
import { FiProfileSizes } from '@fi-shared/profile-icon/profile-icon.component';
import { SharedActionsBaseService } from '@fi-shared/fi-shared-services/shared-actions-base.service';
import { FiImageSize, ObjectTypes } from '@fi-shared/types';

@Component({
    selector: 'fi-comment-simplified-view',
    templateUrl: './fi-comment-simplified-view.component.html',
    styleUrls: ['./fi-comment-simplified-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-comment-simplified-view' },
    standalone: false,
})
export class FiCommentSimplifiedViewComponent {
    @Input({ required: true }) comment: ICommentModel;
    @Input({ required: true }) showEditor: boolean;
    @Input({ required: true }) isDisabled: boolean;
    @Input({ required: true }) commentCopyForEdit: ICommentModel;
    @Input({ required: true }) objectId: number;
    @Input({ required: true }) objectType: ObjectTypes;
    @Input({ required: true }) instanceId: string;

    protected readonly ProfileSizes = FiProfileSizes;
    protected readonly FiImageSize = FiImageSize;

    constructor(
        private commentsListHelperService: FiCommentsListHelperService,
        private sharedActionsBaseService: SharedActionsBaseService,
    ) {}

    protected isCommentChanged(): boolean {
        return this.commentsListHelperService.isCommentChanged(this.comment);
    }

    protected openUserViewPopup($event: MouseEvent) {
        $event.preventDefault();
        this.sharedActionsBaseService.openUserViewPopup(this.comment.CreatedByUserId);
    }

    protected isAttachmentsListShown(): boolean {
        return !!this.comment.MediaBankFileReferences?.length || !!this.comment.Links?.length;
    }
}
